import { Order, ShiftCardFetchOrderQueryVariables, ShiftCardFetchOrderQuery } from 'types/graphql';

import { useGQLQuery } from 'hooks';
import { useMemo } from 'react';
import { useDashboardPageContext } from 'pages/DashboardPage/DashboardPage.context';
import { fetchOrderQueryConfig } from 'pages/DashboardPage/GroupOrdersComponent/GroupOrdersComponent.constants';
import { IGroupOrdersProps } from 'pages/DashboardPage/GroupOrdersComponent/GroupOrdersComponent.types';

export function useGroupOrdersContext<TContext extends Nullable<Order>>(
  props: IGroupOrdersProps,
): {
  order: TContext;
  fetch: () => void;
} {
  const contextValues = useDashboardPageContext();

  const { groupIndex, orderIndex } = props;

  const orderFromContext = useMemo<Nullable<Order>>(() => {
    const orders = contextValues?.data?.fastGroupOrders?.nodes[groupIndex]?.orders;
    return orders ? (orders[orderIndex] as Nullable<Order>) : null;
  }, [contextValues, groupIndex, orderIndex]);

  const result = useGQLQuery<
    ShiftCardFetchOrderQuery,
    ShiftCardFetchOrderQuery,
    ShiftCardFetchOrderQueryVariables
  >(fetchOrderQueryConfig(orderFromContext!.id));

  return {
    order: (result.called ? result.data?.fetchOrder : orderFromContext) as unknown as TContext,
    fetch: result.fetch,
  };
}
